export { GlobalHandlers } from './globalhandlers.js';
export { TryCatch } from './trycatch.js';
export { Breadcrumbs } from './breadcrumbs.js';
export { LinkedErrors } from './linkederrors.js';
export { HttpContext } from './httpcontext.js';
export { Dedupe } from './dedupe.js';

/* eslint-disable deprecation/deprecation */
//# sourceMappingURL=index.js.map



// WEBPACK FOOTER //
// ./~/@sentry/browser/esm/integrations/index.js